import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'rate',
  data: function data() {
    return {
      tableData: [],
      loading: false,
      enabledAdd: true
    };
  },
  mounted: function mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData: function loadTableData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.loading = true;
                _context.next = 4;
                return _this.$api.loadRateList();

              case 4:
                res = _context.sent;
                res.forEach(function (e) {
                  e.isEdit = false;
                  e.money = (e.money / 100).toFixed(2);
                });
                _this.tableData = res;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 12:
                _context.prev = 12;
                _this.loading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9, 12, 15]]);
      }))();
    },
    edit: function edit(row) {
      row.isEdit = true;
    },
    cancel: function cancel(row) {
      if (row.id === '') {
        this.tableData.pop();
        this.enabledAdd = true;
      } else {
        row.isEdit = false;
      }
    },
    save: function save(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var errMsg, params, id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                errMsg = '';

                if (Number(row.isFree) === 0 && row.money <= 0) {
                  errMsg += '金额必须大于0元；';
                }

                if (row.description.length < 2) {
                  errMsg += '缺少说明；';
                }

                if (row.unitvalue <= 0) {
                  errMsg += '有效周期必须大于0；';
                }

                if (row.unit.length === 0) {
                  errMsg += '请选择周期单位；';
                }

                if (!(errMsg.length > 0)) {
                  _context2.next = 8;
                  break;
                }

                _this2.$message({
                  message: errMsg,
                  type: 'error'
                });

                return _context2.abrupt("return");

              case 8:
                _context2.prev = 8;
                params = {
                  id: row.id,
                  money: row.money * 100,
                  description: row.description,
                  unitvalue: row.unitvalue,
                  unit: row.unit,
                  isFree: row.isFree
                };
                _context2.next = 12;
                return _this2.$api.saveRate(params);

              case 12:
                id = _context2.sent;
                row.id = id;
                row.isEdit = false;
                _this2.enabledAdd = _this2.enabledAdd === false;

                _this2.$message({
                  message: '保存成功',
                  type: 'success'
                });

                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](8);

                _this2.$message({
                  message: '保存失败',
                  type: 'error'
                });

                console.log(_context2.t0);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[8, 19]]);
      }))();
    },
    add: function add() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.enabledAdd = false;

                _this3.tableData.push({
                  id: '',
                  money: 0,
                  description: '',
                  unitvalue: 0,
                  unit: '',
                  isFree: 0,
                  isEdit: true
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};